// Query params owned by the shop listing pages (category, search, favourites,
// last ordered, promotion). Navigations use queryParamsHandling: 'merge' to keep
// the global params (customer, department, resident), so every link that
// leaves a listing page spreads this first and then sets its own params.
export const SHOP_LISTING_QUERY_PARAMS_RESET = {
  categoryId: null,
  subcategory: null,
  brands: null,
  sort: null,
  search: null,
  minPrice: null,
  maxPrice: null,
  alternativeFor: null,
  productId: null,
  adBannerId: null,
};
